import React from 'react'
import Header from '../include/Header'
// import { Link } from 'react-router-dom'
import Footer from '../include/Footer'

function AboutUs() {
    return (
        <>
            <Header />
            <div className="page-header bg-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">

                            <div className="page-header-box">
                                <h1 className="wow fadeInUp" data-cursor="-opaque">About <span>us</span></h1>
                              {/*   <nav className="wow fadeInUp" data-wow-delay="0.2s">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">About us</li>
                                    </ol>
                                </nav> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>



            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="cta-box-content">

                                <div className="section-title">
                                    {/* <h3 className="wow fadeInUp">Get in touch</h3> */}
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">

                                        Welcome to <span>[App Name]</span>, a dynamic online streaming platform owned and operated by Innosutra AI Private Limited.
                                        At [App Name], our goal is to redefine how audiences across India enjoy digital entertainment. We bring together a wide spectrum of content—including movies, web series, documentaries, short films, and original productions—so you can watch what you love, whenever you want.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}
                                    </p>
                                    <h5 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Our Vision</span></h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Delivering a Premium Entertainment Experience for Everyone in India
                                        We believe entertainment should be accessible, engaging, and seamless. That’s why our platform is built using modern technology to ensure smooth performance, personalized discovery, and a diverse content lineup tailored to every viewer.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Why Choose [App Name]?</span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Diverse Content Collection

                                        Explore an extensive library featuring films, series, documentaries, short-form content, live programming, and exclusive originals across multiple genres and languages—something for every taste and mood.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Intuitive User Experience</span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Our platform is designed with simplicity and convenience in mind. Enjoy easy navigation, smart recommendations, and a viewing experience tailored to your preferences.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Superior Streaming Quality</span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Experience clear visuals and high-quality audio with optimized streaming performance across devices, ensuring a consistently enjoyable watch.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Blend of Local and Global Content</span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We celebrate India’s cultural richness while also bringing you content from around the world, offering a balanced mix of regional and international entertainment.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Continuous Innovation</span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We are committed to evolving with the latest trends in digital entertainment, constantly improving our platform to deliver better features and richer experiences.
                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>User-First Approach
                                    </span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Your experience matters to us. We actively consider user feedback to refine and enhance our services over time.
                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                    <h4 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Multi-Device Accessibility

                                    </span></h4>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Access [App Name] anytime, anywhere—on smartphones, tablets, and other supported devices—allowing you to switch seamlessly between screens.{/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>
                                </div>

                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>


            <Footer />


        </>
    )
}

export default AboutUs
